export default __webpack_public_path__ + "static/media/plug.f1abe826.webp";